
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface SendAvailabilityReminderRequest {
    profileId: string;
    days?: SendAvailabilityReminderDaysEnum;
}

/**
 * 
 */
export class AvailabilityReminderAdminApi extends runtime.BaseAPI {

    /**
     * Send the availability reminder email to one profile, whatever its last modification date
          */
    async sendAvailabilityReminderRaw(requestParameters: SendAvailabilityReminderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling sendAvailabilityReminder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/availability-reminder/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Send the availability reminder email to one profile, whatever its last modification date
          */
    async sendAvailabilityReminder(requestParameters: SendAvailabilityReminderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.sendAvailabilityReminderRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const SendAvailabilityReminderDaysEnum = {
    NUMBER_14: 14,
    NUMBER_30: 30
} as const;
export type SendAvailabilityReminderDaysEnum = typeof SendAvailabilityReminderDaysEnum[keyof typeof SendAvailabilityReminderDaysEnum];
